import { withLazyFallback } from 'lib/hoc/withLazyFallback';

import PracticesAccess from 'components/admin/pages/Practices/components/PracticesAccess/PracticesAccess';

import LEGACY_CHILDREN from './legacyChildren';
import VIEWPORT_CHILDREN from './viewportChildren';

const NotFound = withLazyFallback(() => import('components/NotFound'));
const PracticesTable = withLazyFallback(
  () => import('components/admin/pages/Practices/PracticesTable')
);
const PracticeProfile = withLazyFallback(() => import('components/admin/pages/Practices/profile'));
const PracticeViewport = withLazyFallback(
  () =>
    import('components/admin/pages/Practices/Viewport/components/PracticeViewport/PracticeViewport')
);
const PracticeCreationWizard = withLazyFallback(
  () => import('components/admin/pages/Practices/PracticeCreationWizard/PracticeCreationWizard')
);

const ADMIN_PRACTICES = [
  {
    path: 'practices',
    element: (
      <PracticesAccess>
        <PracticesTable />
      </PracticesAccess>
    ),
    handle: { title: 'Practices' },
    children: [
      {
        path: ':id',
        element: <PracticeProfile />,
        children: LEGACY_CHILDREN
      },
      {
        path: ':practiceId',
        element: <PracticeViewport />,
        handle: { title: 'Practice viewport' },
        children: VIEWPORT_CHILDREN
      },
      { path: '*', element: <NotFound /> }
    ]
  },
  // Siblings of `practices`, not children of `practices/:id`: the create route
  // has no practice to nest under, and React Router ranks the static `new` and
  // `setup` segments above the `:id` / `:practiceId` params either way.
  {
    path: 'practices/new',
    element: (
      <PracticesAccess>
        <PracticeCreationWizard />
      </PracticesAccess>
    ),
    handle: { title: 'New practice' }
  },
  {
    path: 'practices/:id/setup',
    element: (
      <PracticesAccess>
        <PracticeCreationWizard />
      </PracticesAccess>
    ),
    handle: { title: 'Practice setup' }
  }
];

export default ADMIN_PRACTICES;
